export default "__VITE_ASSET__694afba9__"